import { useEffect, useState } from 'react'
import { onWriteError } from '../lib/writeGuard'

// The visible half of the app-wide write guard (src/lib/writeGuard.js). Mounted once in App.jsx.
//
// A Firestore write denied by rules used to be invisible — the swallowed-catch "button does
// nothing" bug. Every guarded write now reports here, so the user sees WHY instead of wondering
// whether their click registered. Deliberately dumb: no routing, no retry, no state beyond the
// visible queue. Auto-dismisses, because a failed background save shouldn't trap the user in a
// modal, but stays long enough to read (8s).

const LIFETIME_MS = 8000

export default function WriteErrorToast() {
  const [items, setItems] = useState([])

  useEffect(() => onWriteError(({ message, action }) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
    setItems((prev) => {
      // Collapse a repeat of the same action instead of stacking duplicates (a failing
      // fire-and-forget write can fire several times before the user reacts).
      const deduped = prev.filter((it) => it.action !== action)
      return [...deduped, { id, message, action }].slice(-3)
    })
    setTimeout(() => setItems((prev) => prev.filter((it) => it.id !== id)), LIFETIME_MS)
  }), [])

  if (!items.length) return null

  return (
    <div
      className="fixed bottom-4 right-4 z-[9997] flex flex-col gap-2 max-w-sm"
      role="status"
      aria-live="polite"
    >
      {items.map((it) => (
        <div
          key={it.id}
          className="flex items-start gap-2 rounded-lg border border-rose-300 bg-rose-50 px-3 py-2
            text-[13px] text-rose-900 shadow-lg"
        >
          <span aria-hidden className="mt-[1px] shrink-0">⚠</span>
          <span className="flex-1">{it.message}</span>
          <button
            type="button"
            onClick={() => setItems((prev) => prev.filter((x) => x.id !== it.id))}
            className="shrink-0 text-rose-500 hover:text-rose-800 leading-none"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
